import { render, staticRenderFns } from "./SafetyV2.vue?vue&type=template&id=76c175ba&scoped=true"
import script from "./SafetyV2.vue?vue&type=script&lang=js"
export * from "./SafetyV2.vue?vue&type=script&lang=js"
import style0 from "./SafetyV2.vue?vue&type=style&index=0&id=76c175ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c175ba",
  null
  
)

export default component.exports